import React from 'react';
import logo from '../assets/sambas-logo.png';
import './BrandLogo.css';

function BrandLogo() {
  return (
    <div className="brand-logo">
      <img src={logo} alt="SAMBAS Logo" className="logo-image" />
    </div>
  );
}

export default BrandLogo;
